export default __webpack_public_path__ + "static/media/see-icon.007ab020.svg";